import Quill from 'quill';

const FontStyle = Quill.import('attributors/style/font');

// Allow any value
FontStyle.whitelist = null;

export default FontStyle;
